module.exports = __webpack_public_path__ + "images/emoji/pouting_cat.ac6f37a70189eb0b9aad.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/pouting_cat.png
// module id = t0vM
// module chunks = 14